import { render, staticRenderFns } from "./waitList.vue?vue&type=template&id=1d5894ea&scoped=true&"
import script from "./waitList.vue?vue&type=script&lang=js&"
export * from "./waitList.vue?vue&type=script&lang=js&"
import style0 from "./waitList.vue?vue&type=style&index=0&id=1d5894ea&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5894ea",
  null
  
)

export default component.exports